import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import rootReducer from './reducer'
import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux'
import {BrowserRouter, Route, Routes,HashRouter} from 'react-router-dom'
import Home from "./view/home";
import Login from "./view/login";


const store = configureStore({
    reducer: rootReducer
})

ReactDOM.render(
      <Provider store={store}>
          <BrowserRouter basename='/demo'>
              <App />
          </BrowserRouter>
      </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))

